// extracted by mini-css-extract-plugin
export default {"container":"responsibleParty_container__9mBgU","static":"responsibleParty_static__ceB7-","staticContent":"responsibleParty_staticContent__Dz5fR"};